import { render, staticRenderFns } from "./ChangeUserPass.vue?vue&type=template&id=9455c4c8&scoped=true&"
import script from "./ChangeUserPass.vue?vue&type=script&lang=js&"
export * from "./ChangeUserPass.vue?vue&type=script&lang=js&"
import style0 from "./ChangeUserPass.vue?vue&type=style&index=0&id=9455c4c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9455c4c8",
  null
  
)

export default component.exports
import {QTooltip,QBtn} from 'quasar'
component.options.components = Object.assign({QTooltip,QBtn}, component.options.components || {})
